import { render, staticRenderFns } from "./update-grade.vue?vue&type=template&id=893b75de&lang=pug"
import script from "./update-grade.vue?vue&type=script&lang=js"
export * from "./update-grade.vue?vue&type=script&lang=js"
import style0 from "./update-grade.vue?vue&type=style&index=0&id=893b75de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports